import { PageHeader } from '@/components/common/page-header';
import { History } from 'lucide-react';
import { EmptyState, ErrorState } from '@/components/common/states';
import { MovieCard } from '@/components/movie/movie-card';
import { MovieGrid, MovieGridSkeleton, MOVIE_GRID_CLASSES } from '@/components/movie/movie-grid';
import { useHistory } from '@/hooks/use-movies';
import { Actresses } from './collections-page';

export function WatchlistPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Watchlist" description="Movies saved for later, oldest first. A movie leaves on its own once you finish it." />
      <MovieGrid request={{ watchlist: true }} empty={{ title: 'Your watchlist is empty', description: 'Use the bookmark on any movie to save it here.' }} />
    </div>
  );
}

export function FavouritesPage() {
  return (
    <div className="space-y-8">
      <PageHeader title="Favourites" />
      <section className="space-y-3">
        <h2 className="font-display text-xl">Actresses</h2>
        <Actresses favourites />
      </section>
      <section className="space-y-3">
        <h2 className="font-display text-xl">Movies</h2>
        <MovieGrid request={{ favourite: true }} empty={{ title: 'No favourite movies yet', description: 'The heart on a movie page adds it here.' }} />
      </section>
    </div>
  );
}

export function HiddenPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Hidden" description="Movies kept out of browsing and search. Open one to unhide it." />
      <MovieGrid request={{ hidden: true }} empty={{ title: 'Nothing hidden' }} />
    </div>
  );
}

export function HistoryPage() {
  const history = useHistory();
  return (
    <div className="space-y-6">
      <PageHeader title="History" description="What you watched, most recent first. The bar on each cover is how far you got." />
      {history.isPending ? (
        <MovieGridSkeleton />
      ) : history.isError ? (
        <ErrorState error={history.error} onRetry={() => void history.refetch()} />
      ) : history.data.movies.length === 0 ? (
        <EmptyState title="Nothing watched yet" description="Movies you play appear here." icon={<History className="size-5" />} />
      ) : (
        <div className={MOVIE_GRID_CLASSES}>
          {history.data.movies.map((movie) => (
            <MovieCard key={movie.movieId} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
}
